import React, { Component } from 'react'
import { Row, Col, Spin, Card, Button, Form, Icon, Modal, Input, Upload, Carousel } from 'antd'
import { app, api, config } from "../../app"
import '../../css/expert.css'
import Head from "../../components/Head"
import Iconz from "../../components/Iconz"
import 'braft-editor/dist/output.css'
import moment from "moment"

const FormItem = Form.Item;

/**
 * 上传之前2
 * @param file
 */
function beforeUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg】！', 'error')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

class EDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.match.params.id,
            isShowClue: false,
            imgBox: [],
            family_info2: null,
            expert_info: {
                // head_img: '/Uploads/Photo/20230223/63f7145981e2f.png',
                // name: '赵东来',
                // sex: '男',
                // age: 18,
                // height: 180,
                // feature: '牛高马大，帅气逼人',
                // id: 123,
                // img: 'https://tp.blueskyrescue.cn/Uploads/Photo/20230223/63f7145981e2f.png',
                // date: '2008-01-06',
                // region: '河北省',
                // region2: '石家庄市',
                // adress: '河北省邢台市隆尧县固城镇大营村',
                // weight: '1800kg',
                // way: '15*******36',
                // mark: '提供线索者必有重谢！',
                // status: '寻找中',
                // wayName: '赵*来',
                // imgList: [
                //     'http://n.sinaimg.cn/sinacn/20170408/5d96-fyecfak9811578.jpg',
                //     'http://n.sinaimg.cn/sinacn/20170408/76ec-fyeceza1481183.jpg',
                //     'http://p0.ifengimg.com/pmop/2017/0425/9AC13C7C3D11E77DD9F6D155383914E446D61080_size48_w1000_h750.jpeg'
                // ],
                // kaiguang: '睡醒就不见人了'
            },
            detail_loading: false
        }
    }

    componentDidMount() {
        this._isMounted = true
        // console.log(this.props)
        this.detailSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 详情数据
     */
    detailSource = async () => {
        const params = {
            id: this.state.id,
            lost_token: app.getData('findAsstoken'), // 登录token
        }
        let { flag, data, msg } = await app.post(api.LostMessageDetail, params)
        const state = { detail_loading: false }
        if (flag === 1) {
            let data2 = data.origin_data;
            state.expert_info = data2;
            state.family_info2 = data2.family_info !== null ? data2.family_info : null;
            // let a = data2.family_info !== null ? data2.family_info : null;
            // console.log(a.family_name1)
            // console.log(data2.family_info !== null ? data2.family_info : null);
            state.imgBox = data2.img_path !== '' ? data2.img_path.split(":::") : []
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    // 是否显示提供线索框
    onChangeClue = () => {
        const { isShowClue } = this.state;
        if (isShowClue) {
            this.setData({
                isShowClue: false,
            })
        } else {
            this.setData({
                isShowClue: true,
            })
        }
    }

    // 提交线索
    handleSubmit = (e) => {
        e.preventDefault()
        // console.log('提交成功，感谢您提供的线索！');
        app.alert('提交成功，感谢您提供的线索！', 'success')
        setTimeout(() => {
            this.onChangeClue();
        }, 500);
    }

    // 返回大厅
    getBack = () => {
        this.props.history.goBack();
    }

    // 计算年龄（仅计算年龄以及月龄）
    getAge(e) {
        let nowYear = new Date().getFullYear();
        let targetYear = Number(moment(e).format("YYYY"));
        // console.log(nowYear, targetYear);
        // return '8岁'
        // 如果是同一年，则判断月份
        if (nowYear === targetYear) {
            let nowMonth = new Date().getMonth() + 1;
            // 注意：getMonth返回值是0(1月)~11(12月)之间的一个整数，月份从0开始，11结束，0就是1月
            // moment().format("MM")也是如此
            let targetMonth = Number(moment(e).format("MM"));
            console.log(nowMonth, targetMonth, e);
            // 如果月份相同，则判断天数
            if (nowMonth === targetMonth) {
                return '未满月';
            } else {
                return nowMonth - targetMonth + '月';
            }
        } else {
            return nowYear - targetYear + '岁';
        }
    }

    render() {
        let { expert_info, imgBox, detail_loading, isShowClue, family_info2 } = this.state,
            { getFieldDecorator } = this.props.form;
        return (
            <div className="expert-page-detail">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48} />
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history} />
                <div className="ep-content" style={{ background: 'none' }}>
                    <div className="epc-title" style={{ marginTop: 24 }}>寻人详情</div  >
                    <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-end', width: '1190px', marginBottom: 24, marginTop: 12 }}>
                        <span onClick={() => this.getBack()} style={{ color: '#1890ff', cursor: 'pointer' }}>
                            返回上一级
                        </span>
                    </div>
                    <div className="epc-content" style={{
                        padding: 0
                    }}>
                        {
                            detail_loading ? (
                                <div style={{ textAlign: 'center' }}><Spin size="large" /></div>
                            ) : (
                                <div>
                                    <Row gutter={12} style={{ marginBottom: 100 }}>
                                        <Col span={12}>
                                            <Col span={24}>
                                                <Card title="基本信息" size='small'>
                                                    <div style={styles.flexBox}>
                                                        <div style={styles.imgBox}>
                                                            <img style={{ ...styles.img, borderRadius: '4px' }}
                                                                src={config.imgUrl + app.urlEncode(imgBox[0] || '-')} alt="头像" />
                                                        </div>
                                                        <div style={styles.userInfo}>
                                                            <div style={styles.epcciItem}>
                                                                <span>姓名：</span>
                                                                <span style={styles.epccicontent}>{expert_info.name || '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>性别：</span>
                                                                <span style={styles.epccicontent}>{expert_info.sex || '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>年龄：</span>
                                                                <span style={styles.epccicontent}>{expert_info.date !== '' ? this.getAge(expert_info.date) : '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>身高：</span>
                                                                <span style={styles.epccicontent}>{expert_info.height || '-'}cm</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪日期：</span>
                                                                <span style={styles.epccicontent}>{expert_info.date ? moment(expert_info.date).format("YYYY-MM-DD") : '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪地区：</span>
                                                                <span style={styles.epccicontent}>{expert_info.province || '-未知省-'}/{expert_info.city || '-未知市-'}/{expert_info.district || '-未知区-'}</span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col span={24} style={styles.gutter}>
                                                <Card title="失踪详情" size='small'>
                                                    <div style={styles.flexBox}>
                                                        <div style={{ ...styles.userInfo, margin: 0 }}>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪地址：</span>
                                                                <span style={styles.epccicontent}>{expert_info.address || '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪人特征：</span>
                                                                <span style={styles.epccicontent}>{expert_info.feature || '-'}</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪时体重：</span>
                                                                <span style={styles.epccicontent}>{expert_info.weight || '-'}kg</span>
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>失踪概况：</span>
                                                                <span style={styles.epccicontent}>{expert_info.descript || '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col span={24} >
                                                <Card title="其他信息" size='small'>
                                                    <div style={styles.flexBox}>
                                                        <div style={{ ...styles.userInfo, margin: 0 }}>
                                                            <div style={styles.epcciItem}>
                                                                <span>联系方式：</span>
                                                                {
                                                                    family_info2 !== null ?
                                                                        (
                                                                            family_info2.family_name1 !== null && family_info2.family_name1 !== '' ?
                                                                                <span style={styles.epccicontent}>{family_info2.family_name1 || '-'}({family_info2.family_phone1 || '-'})</span>
                                                                                :
                                                                                null
                                                                        )
                                                                        :
                                                                        null
                                                                    }
                                                                    {
                                                                        family_info2 !== null ?
                                                                            (
                                                                                family_info2.family_name1 !== null && family_info2.family_name1 !== '' && family_info2.family_name2 !== null && family_info2.family_name2 !== '' ?
                                                                                    <span>、</span>
                                                                                    :
                                                                                    null
                                                                            )
                                                                            :
                                                                            null
                                                                    }
                                                                {
                                                                    family_info2 !== null ?
                                                                        (
                                                                            family_info2.family_name2 !== null && family_info2.family_name2 !== '' ?
                                                                                <span style={styles.epccicontent}>{family_info2.family_name2 || '-'}({family_info2.family_phone2 || '-'})</span>
                                                                                :
                                                                                null
                                                                        )
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            <div style={styles.epcciItem}>
                                                                <span>寻找状态：</span>
                                                                <span style={styles.epccicontent}>{expert_info.flag_title || '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Card>
                                            </Col>
                                        </Col>

                                        <Col span={12}>
                                            <Col span={24}>
                                                <Card title="相关照片" size='small'>
                                                    <Carousel
                                                    >
                                                        {
                                                            imgBox.map((e, i) => {
                                                                return (
                                                                    <div key={i} style={{
                                                                        // display: 'flex',
                                                                        // alignItems: 'center',
                                                                        // width: '509px',
                                                                        // height: '540px',
                                                                    }}>
                                                                        <img style={{ maxWidth: '509px', maxHeight: '540px', borderRadius: '4px' }}
                                                                            src={config.imgUrl + e} alt="相关照片" />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </Carousel>
                                                    {/* <div style={styles.flexBox}>
                                                    {
                                                        expert_info.imgList.map((e, i) => {
                                                            return (
                                                                <img key={i} style={{ ...styles.img, ...styles.marlr, borderRadius: '4px' }}
                                                                    src={e} alt="相关照片" />
                                                            )
                                                        })
                                                    }
                                                </div> */}
                                                </Card>

                                            </Col>
                                            <Col span={24} style={styles.gutter}>
                                                <div style={{ ...styles.flexBox, justifyContent: 'flex-end', alignItems: 'center' }}>
                                                    <Button
                                                        type='danger'
                                                        style={{
                                                            marginRight: '12px'
                                                        }}
                                                        onClick={() => this.onChangeClue()}
                                                    >
                                                        <Icon type="bulb" />
                                                        提供线索</Button>
                                                    <Button
                                                        type='primary'
                                                        onClick={() => this.onChangeClue()}
                                                    >
                                                        <Icon type="phone" />
                                                        联系登记人</Button>
                                                </div>
                                            </Col>

                                        </Col>
                                        {/* <Col span={12} style={styles.gutter}>

                                        </Col>
                                        <Col span={12} style={styles.gutter}>

                                        </Col> */}
                                    </Row>
                                </div>
                            )
                        }
                    </div>
                </div>
                <Modal
                    visible={isShowClue}
                    title='我要提供线索'
                    maskClosable={false}
                    width='768px'
                    footer={null}
                    style={{ padding: 0 }}
                    destroyOnClose={true}
                    // bodyStyle={{ height: '100vh', overflow: 'auto' }}
                    onCancel={this.onChangeClue}
                >
                    <Form
                        layout='inline'
                        onSubmit={(e) => this.handleSubmit(e)}
                    >
                        <Row gutter={18}>
                            <Col span={24}>
                                <FormItem
                                    label="线索内容"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('report_name', {
                                        // rules: [
                                        //     { required: true, message: '请输入发布人姓名' }
                                        // ],
                                    })(
                                        <Input.TextArea style={{ width: '630px' }} rows={4} placeholder="请输入内容" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    label="相关照片"
                                // {...formItemLayout(20)}
                                >
                                    {getFieldDecorator('certificate_img', {
                                        valuePropName: 'fileList',
                                        getValueFromEvent: (e) => {
                                            if (Array.isArray(e)) {
                                                return e
                                            }
                                            return e && e.fileList
                                        },
                                        initialValue: expert_info ? (expert_info.certificate_img || []).map((img, i) => {
                                            i += 1
                                            return {
                                                uid: i - i * 2,
                                                status: 'done',
                                                response: {
                                                    flag: 1,
                                                    data: {
                                                        url: img
                                                    }
                                                },
                                                name: "图片" + i,
                                                thumbUrl: config.imgUrl + img
                                            }
                                        }) : []
                                    })(
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            action={config.serverUrl + api.ImageUpload}
                                            beforeUpload={beforeUpload}
                                            multiple={true}
                                            data={{
                                                token: app.getData('token'),
                                                indexno: app.getData('indexno'),
                                                account: app.getData('account'),
                                                upload_type: 'expert_certificate'
                                            }}
                                            name="image"
                                            listType="picture"
                                            showUploadList={true}
                                            className="upload-list-inline"
                                        >
                                            <Button type="primary">
                                                <Icon type="upload" /> 点击上传
                                            </Button>
                                        </Upload>
                                    )}
                                    (最多上传3张照片，默认显示首张)
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    label="温馨提示"
                                // {...formItemLayout(20)}
                                >
                                    <div>1.留言后登记人会立即收到您的线索留言</div>
                                    <div>2.登记人预留手机号会收到短信线索提醒（停机会发送失败）</div>
                                    <div>3.请您遵守国家法律法规，您对您的留言负有法律责任</div>
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <div style={{ ...styles.flexBox, justifyContent: 'flex-end' }}>
                                    <Button style={{ marginRight: '12px' }} onClick={() => this.onChangeClue()}>取消</Button>
                                    <Button type='primary' htmlType="submit">提交</Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(EDetail)

const styles = {
    flexBox: {
        display: 'flex',
    },
    gutter: {
        marginTop: '24px',
        marginBottom: '24px'
    },
    imgBox: {
        width: '158px',
        height: '222px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f9f9f9',
        borderRadius: '4px'
    },
    img: {
        maxWidth: '158px',
        maxHeight: '222px',
    },
    marlr: {
        marginLeft: '10px',
        marginRight: '10px'
    },
    userInfo: {
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        marginLeft: '24px'
    },
    otherInfo: {
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        marginLeft: '48px'
    },
    epcciItem: {
        marginBottom: '8px',
        fontWeight: 600
    },
    epccicontent: {
        color: '#999',
        fontWeight: 500
    }

}


// WEBPACK FOOTER //
// ./src/routes/find/FDetail.jsx